module.exports = __webpack_public_path__ + "img/blockdaemon.401b36da.svg";